import React from 'react';

const AIWarmLeadsCampaigns: React.FC = () => {
  return (
    <div className="d-flex-center size-max">
      <h1 className="auth-title mb-1_25rem">AI Warm Leads Campaigns</h1>
    </div>
  );
};

export default AIWarmLeadsCampaigns;
